<template>
  <div class="kyc-list container is-fluid">
    <div class="kyc-list__header">
      <div>
        <vue-typed-js
          :strings="['KYC Forms', 'Know Your Client', 'Know Your Client Forms' ,'Know Your Client']"
          :typeSpeed="150"
          :backSpeed="150"
          :backDelay="150"
        >
          <h3><span class="typing"></span></h3>
        </vue-typed-js>
      </div>

      <div>
        <router-link tag="button" class="button is-primary" to="/new">New form</router-link>
      </div>
    </div>

    <kyc-admin-filters/>

    <kyc-list :kycList="kycList"/>

  </div>
</template>

<script>
import { mapState } from 'vuex'

import KycAdminFilters from '@/components/KycAdminFilters'
import KycList from '@/components/KycList'

export default {
  name: 'KycAdmin',
  components: {
    KycAdminFilters,
    KycList
  },
  data () {
    return {
    }
  },
  created () {
    this.$store.dispatch('getStaff')
    this.getData()
  },
  computed: {
    ...mapState([
      'staff',
      'kycList',
      'listShowCompletedForms',
      'staffIdFilterBy',
      'statusIdFilterBy',
      'searched'
    ])
  },
  watch: {
    listShowCompletedForms () {
      this.getData()
    },
    staffIdFilterBy () {
      this.$store.dispatch('getKycList')
    },
    statusIdFilterBy () {
      this.$store.dispatch('getKycList')
    }
  },
  methods: {
    getData () {
      if (this.searched) {
        this.$store.dispatch('searchKyc')
      } else {
        this.$store.dispatch('getKycList')
      }
    }
  }
}
</script>

<style scoped>

.kyc-list__header {
  align-items: baseline;
  display: flex;
  justify-content: space-between;
}

.kyc-list__header h3 {
  font-size: 2em;
  line-height: 2.5em;
  margin: 0;
  padding: 0;
}

</style>
